import { ButtonSelect } from '../../Select'

import * as styles from './EntityActionTypeSelect.module.css'

function EntityActionTypeSelect(props) {
  return (
    <ButtonSelect
      {...props}
      className={styles.selectWrapper}
      controlProps={{
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
    />
  )
}

export default EntityActionTypeSelect
